module.exports = __webpack_public_path__ + "static/media/tree_logoTop.823b62fe.png";